import { render, staticRenderFns } from "./PriorityTreeReadOnlyView.vue?vue&type=template&id=2f2fddb0&scoped=true&"
import script from "./PriorityTreeReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./PriorityTreeReadOnlyView.vue?vue&type=script&lang=js&"
import style0 from "./PriorityTreeReadOnlyView.vue?vue&type=style&index=0&id=2f2fddb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2fddb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {VCard,VFlex})
